<template>
	<div class="appoint-gift-wrap">
		<p class="title">礼物</p>
		<div class="choosed-gift-list">
			<ul>
				<li v-for="item in choosedGiftList">
					<img :src="item.girft_img_url" alt="" />
					<p>{{item.girft_name}}</p>
					<span class="item-num">{{item.num}}</span>
				</li>
				<li @click="showAllGift=1">
					<img src="../../assets/img/finds/ic_btn_add@2x.png" alt="" />
				</li>
			</ul>
		</div>
		<div class="all-gift-list" v-if="showAllGift==1"  @click.self="showAllGift=0">
			<div class="list-swiper">
				<div class="swiper-container">
					<div class="swiper-wrapper">
						<div class="swiper-slide" v-for="item in allGiftList" :class="{'active':item.g_id==choosedGiftId}" @click="chooseGift(item)">
							<img :src="item.girft_img_url" alt="" />
							<p class="item-name">{{item.girft_name}}</p>
							<p class="item-price">{{item.price}}桃花币</p>
						</div>
					</div>
					<!-- Add Pagination -->
					<div class="swiper-pagination"></div>
				</div>
				<div class="add-gift">
					<div class="gift-num">
						礼物数量:
						<input type="number" value="1" min="1" v-model="choosedGiftNum"/>
					</div>
					<button @click="addChoosedGift">添加礼物</button>
				</div>
			</div>
			
		</div>
		
	</div>
</template>

<script>
	import 'swiper/dist/css/swiper.css';

	import Swiper from 'swiper';

	export default {
		name: "appoint-gift",
		data() {
			return {
				choosedGiftList: [],
				allGiftList: [],
				showAllGift:0,
				choosedGift:"",
				choosedGiftId:"",
				choosedGiftNum:1,
			}
		},
		mounted() {

		},
		watch:{
			showAllGift(){
				if(this.showAllGift==1){
					setTimeout(function() {
						var swiper = new Swiper('.swiper-container', {
							slidesPerView: 4,
							slidesPerColumn: 2,
							pagination: {
								el: '.swiper-pagination',
								clickable: true,
							},
						});
					}, 800)
				}
			}
		},
		created() {
			this.getGiftList();
		},
		methods: {
			getGiftList() {
				this.$axios.get("gift/giftList").then(res => {
					console.log(res);
					if(res.data.code == 200) {
						this.allGiftList = res.data.data;
					}
				}).catch(err => {
					console.log(err)
				})
			},
			chooseGift(item){
				this.choosedGift = item;
				this.choosedGiftId = item.g_id;
			},
			addChoosedGift(){
				this.choosedGift.num = this.choosedGiftNum;
				this.choosedGiftList.push(this.choosedGift);
				this.showAllGift = 0;
				this.$emit("chooseGift",this.choosedGiftList)
			}
		}
	}
</script>

<style scoped>
	.appoint-gift-wrap {
		padding: 0.5rem 1rem 0;
	}
	
	.appoint-gift-wrap .title {
		background: url(../../assets/img/finds/ic_list_tab@2x.png) no-repeat left center;
		background-size: contain;
		padding-left: 1.6rem;
		font-size: 1rem;
		color: #282828;
		font-weight: bold;
		line-height: 1.5rem;
		margin: 0.5rem 0;
	}
	
	.choosed-gift-list ul {
		display: flex;
		justify-content: flex-start;
		align-items: flex-start;
		flex-wrap: wrap;
	}
	
	.choosed-gift-list li {
		width: 25%;
		text-align: center;
		position: relative;
		padding: 0.5rem 0;
		font-size: 0.8rem;
		color: #7b7b7b;
	}
	
	.choosed-gift-list li img {
		width: 3rem;
	}
	
	.choosed-gift-list li .item-num {
		position: absolute;
		top: 0;
		left: 0.5rem;
		width: 1.2rem;
		height: 1.2rem;
		background: #ff6161;
		color: #fff;
		display: flex;
		justify-content: center;
		align-items: center;
		border-radius: 50%;
	}
	
	.all-gift-list {
		width: 100%;
		height: 100%;
		position: fixed;
		top: 0;
		left: 0;
		background: rgba(0, 0, 0, .2);
	}
	
	.all-gift-list .list-swiper {
		position: absolute;
		width: 100%;
		left: 0;
		bottom: 0;
		background: #fff;
		padding: 1rem 0;
		border-radius: 1rem 1rem 0 0;
	}
	
	.all-gift-list .list-swiper img {
		width: 3rem;
	}
	
	.swiper-container {
		width: 100%;
		height: auto;
		margin-left: auto;
		margin-right: auto;
		padding: 0 0 2rem;
	}
	
	>>>.swiper-pagination-bullet{
		background: #5415F9;
		opacity: 0.3;
	}
	>>>.swiper-pagination-bullet-active{
		opacity: 1;
	}
	
	.all-gift-list .swiper-slide {
		text-align: center;
		font-size: 0.8rem;
		padding: 0.5rem 0;
		border: 1px solid transparent;
	}
	.all-gift-list .swiper-slide.active{
		border: 1px solid #5415F9;
	}
	.all-gift-list .swiper-slide .item-name{
		color: #282828;
		line-height: 1.5rem;
		font-size: 0.9rem;
		font-weight: bold;
	}
	.all-gift-list .swiper-slide .item-price{
		color: #5415F9;
	}
	.all-gift-list .add-gift{
	    display: flex;
	    justify-content: space-between;
	    align-items: center;
	    padding: 0 1rem;
	}
	.all-gift-list .add-gift .gift-num{
		background: #ffdfdf;
		display: flex;
		justify-content: center;
		align-items: center;
		flex: 1;
		margin-right: 2rem;
		font-size: 0.8rem;
		padding: 0.4rem 0;
		border-radius: 3rem;
	}
	.all-gift-list .add-gift .gift-num input{
		width: 3rem;
		padding: 0.2rem 0;
		text-align: center;
		border: 0;
		outline: 0;
		background: transparent url(../../assets/img/finds/ic_pop_shuliang@2x.png) no-repeat right bottom;
		background-size: 1rem;
	}
	.all-gift-list .add-gift button{
		background: linear-gradient(to right,#7644fa,#9d7cff);
		padding: 0.5rem 1rem;
		border: 0;
		outline: 0;
		border-radius: 3rem;
		color:#fff;
	}
</style>


// WEBPACK FOOTER //
// src/components/Common/AppointGift.vue